module.exports = __webpack_public_path__ + "assets/img/btn_recharge.fce44e81.png";